'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'envelope-dot';
var width = 576;
var height = 512;
var aliases = ["envelope-badge"];
var unicode = 'e16f';
var svgPathData = ['M48 119.9C48 97.9 65.9 80 87.9 80L368 80c0 53.9 33.4 100.1 80.6 118.9L321.4 293.3c-19.8 14.7-46.9 14.7-66.7 0L64.1 151.9C54 144.4 48 132.5 48 119.9zM48 159c2 2.1 4.2 4 6.6 5.7L245.1 306.1c25.5 18.9 60.3 18.9 85.8 0L467.5 204.8c9.2 2.1 18.7 3.2 28.5 3.2 11.1 0 21.8-1.4 32-4l0 180c0 26.5-21.5 48-48 48L96 432c-26.5 0-48-21.5-48-48l0-225z', 'M560 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM87.9 64L369 64c-.7 5.2-1 10.6-1 16L87.9 80c-22 0-39.9 17.9-39.9 39.9 0 12.6 6 24.5 16.1 32L254.6 293.3c19.8 14.7 46.9 14.7 66.7 0l127.2-94.4c6.1 2.4 12.4 4.4 18.9 5.9L330.9 306.1c-25.5 18.9-60.3 18.9-85.8 0L54.6 164.8C52.2 163 50 161.1 48 159l0 225c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-180c5.5-1.4 10.8-3.2 16-5.3L544 384c0 35.3-28.7 64-64 64L96 448c-35.3 0-64-28.7-64-64l0-264.1C32 89 57 64 87.9 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;